import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit {
  return: string = '';
  error: any;
  isLoading = false;
  showLinkingOptions = false;
  linkingError: any;
  linkingSuccess = false;
  
  constructor(public authService : AuthService , private route: ActivatedRoute) { }

  ngOnInit() { }
  onSignin(form:NgForm){
    const email = form.value.email
    const password = form.value.password
 
    this.authService.signinUser(email, password, true).then(() => {
      // Show linking options after successful email/password login
      this.showLinkingOptions = true;
      // Auto-hide linking options after 30 seconds and navigate
      setTimeout(() => {
        if (this.showLinkingOptions) {
          this.proceedToDashboard();
        }
      }, 30000);
    }).catch(err=>{
      this.error = err;
    })
  }

  valid(form:NgForm){
    return !form.invalid;
  }

  onGoogleSignin() {
    this.error = null;
    this.isLoading = true;
    this.authService.signInWithGoogle().catch(err => {
      this.error = err;
      this.isLoading = false;
    }).finally(() => {
      this.isLoading = false;
    });
  }

  onMicrosoftSignin() {
    this.error = null;
    this.isLoading = true;
    this.authService.signInWithMicrosoft().catch(err => {
      this.error = err;
      this.isLoading = false;
    }).finally(() => {
      this.isLoading = false;
    });
  }

  // Account linking methods
  linkGoogleAccount() {
    this.linkingError = null;
    this.authService.linkGoogleAccount().then(() => {
      this.linkingSuccess = true;
      setTimeout(() => {
        this.linkingSuccess = false;
        this.proceedToDashboard();
      }, 3000);
    }).catch(err => {
      this.linkingError = err;
    });
  }

  linkMicrosoftAccount() {
    this.linkingError = null;
    this.authService.linkMicrosoftAccount().then(() => {
      this.linkingSuccess = true;
      setTimeout(() => {
        this.linkingSuccess = false;
        this.proceedToDashboard();
      }, 3000);
    }).catch(err => {
      this.linkingError = err;
    });
  }

  dismissLinkingOptions() {
    this.proceedToDashboard();
  }

  proceedToDashboard() {
    this.showLinkingOptions = false;
    this.authService.navigateToDashboard();
  }
}
